<template>
  <div class="layout">
    <HeadMenu />
    <router-view />
    <FooterSection />
    <!-- 客服聊天悬浮入口（登录后显示） -->
    <ChatWidget />
  </div>
</template>
<script>
import HeadMenu from "./HeadMenu.vue";
import FooterSection from "./FooterSection.vue";
import ChatWidget from "./chat/ChatWidget.vue";
export default {
  name: "LayoutComponent",
  components: {
    HeadMenu,
    FooterSection,
    ChatWidget,
  },
};
</script>
